import {  doPost } from "./RESTUtils";

export const loginService = async (userName, password) => {
  return await doPost(`/Logics/user/login`, { userName, password });
};
